export default __webpack_public_path__ + "static/media/bridging-the-gap-mobile.1cd77769.png";